import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-35ae00fc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "add_link_show_view_bg" }
const _hoisted_2 = { class: "top_view" }
const _hoisted_3 = {
  key: 0,
  class: "tips_bg"
}
const _hoisted_4 = { class: "center_content_view" }
const _hoisted_5 = { class: "link_info_bg" }
const _hoisted_6 = { class: "link_head" }
const _hoisted_7 = ["src"]
const _hoisted_8 = { class: "link_info_describe" }
const _hoisted_9 = { class: "input-wrapper" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "标题：", -1))
const _hoisted_11 = { class: "input-content" }
const _hoisted_12 = { class: "input-wrapper" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "链接：", -1))
const _hoisted_14 = { class: "input-content" }
const _hoisted_15 = {
  class: "link_icon_list",
  style: {"overflow":"auto"}
}
const _hoisted_16 = { class: "search-icon-content" }
const _hoisted_17 = ["onClick", "onMouseenter", "onMouseleave"]
const _hoisted_18 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BackButtonItem = _resolveComponent("BackButtonItem")!
  const _component_el_input = _resolveComponent("el-input")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_BackButtonItem, {
        onBackBtnClick: _ctx.backButtonClick,
        class: "back_button"
      }, null, 8, ["onBackBtnClick"]),
      _createElementVNode("button", {
        class: "submit_button",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.submitClick && _ctx.submitClick(...args)))
      }, "确认")
    ]),
    (_ctx.tipsText)
      ? (_openBlock(), _createElementBlock("span", _hoisted_3, "*" + _toDisplayString(_ctx.tipsText), 1))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("img", {
            class: "link_img",
            src: _ctx.selectSocialLink.icon,
            alt: ""
          }, null, 8, _hoisted_7)
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _hoisted_10,
            _createElementVNode("div", _hoisted_11, [
              _createVNode(_component_el_input, {
                modelValue: _ctx.selectSocialLink.name,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.selectSocialLink.name) = $event)),
                placeholder: "请输入标题"
              }, null, 8, ["modelValue"])
            ])
          ]),
          _createElementVNode("div", _hoisted_12, [
            _hoisted_13,
            _createElementVNode("div", _hoisted_14, [
              _createVNode(_component_el_input, {
                modelValue: _ctx.selectSocialLink.url,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.selectSocialLink.url) = $event)),
                placeholder: "请输入链接"
              }, null, 8, ["modelValue"])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_15, [
        _createElementVNode("ul", _hoisted_16, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.socialIconList, (item, index) => {
            return (_openBlock(), _createElementBlock("li", {
              class: _normalizeClass(item.icon === _ctx.selectSocialLink.icon ? 'link-active' : ''
                ),
              key: item.icon,
              onClick: ($event: any) => (_ctx.selectLink(item)),
              onMouseenter: ($event: any) => (_ctx.handleMouseEnter(index)),
              onMouseleave: ($event: any) => (_ctx.handleMouseLeave(index)),
              style: _normalizeStyle(_ctx.itemStyle(index))
            }, [
              _createElementVNode("img", {
                src: item.icon,
                alt: ""
              }, null, 8, _hoisted_18)
            ], 46, _hoisted_17))
          }), 128))
        ])
      ])
    ])
  ]))
}